module.exports = __webpack_public_path__ + "files/a7471a1fbc36756bbe8a74f9c006d694.png";